<template>
  <el-card>
    <section>
      <!--工具条-->
      <el-col :span="24" class="form-line">
        <el-form size="small" :inline="true" :model="filters">
          <el-form-item label="消息状态">
            <el-select clearable v-model="filters.status" placeholder="请选择状态">
              <el-option
                v-for="item in statusType"
                :key="item.id"
                :label="item.statusName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <div style="float: right">
            <el-form-item>
              <el-button-group>
                <el-button type="primary" icon="el-icon-search" @click="getMessageList()">查询</el-button>
                <el-button icon="el-icon-refresh-right" @click="resetFilter()">重置</el-button>
              </el-button-group>
            </el-form-item>
            <el-form-item>
              <el-button-group>
                <el-button type="primary" icon="el-icon-search" @click="handleAllRead()">全部已读</el-button>
              </el-button-group>
            </el-form-item>
          </div>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table border size="medium" :data="messageList" highlight-current-row v-loading="listLoading" @selection-change="selsChange">
        <el-table-column type="index" min-width="60">
        </el-table-column>
        <el-table-column prop="pushMessage.messageTitle" label="消息标题" min-width="120">
        </el-table-column>
        <el-table-column prop="pushMessage.messageContent" label="消息内容" min-width="240">
        </el-table-column>
        <el-table-column prop="pushMessage.createDate" label="通知时间" min-width="120">
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="120" :formatter="statusFormatter">
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 1" type="text" size="small" @click="readMessage(scope.row.id)">确认已读</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--工具条-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="padding: 15px 5px">
      </el-pagination>

      <!--新增界面-->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form size="small" :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="角色名称" prop="roleName">
            <el-input v-model="addForm.roleName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="角色备注">
            <el-input type="textarea" v-model="addForm.description"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="addFormVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </el-card>
</template>

<script>

import { doPost, download } from '../../api/api'

export default {
  data () {
    return {
      filters: {
        systemFlag: 'service-mdinfo',
        roleName: '',
        status: ''
      },
      statusType: [
        { id: 1, statusName: '未读' },
        { id: 2, statusName: '已读' }
      ],
      messageList: [],
      total: 0,
      listLoading: false,
      sels: [], // 列表选中列

      addFormVisible: false, // 新增界面是否显示
      addLoading: false,
      addFormRules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      // 新增界面数据
      addForm: {
        systemFlag: 'service-mdinfo',
        roleName: '',
        description: ''
      },
      messageTitle: '',
      messageSuc: '',
      value: '',
      value1: new Date(2016, 9, 10, 18, 40),
      value2: '',
      value3: '',
      user: {}
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.pageSize = val
      this.getMessageList()
    },
    handleCurrentChange (val) {
      this.filters.pageNum = val
      this.getMessageList()
    },
    resetFilter () {
      Object.assign(this.$data.filters, this.$options.data().filters)
    },
    // 获取消息列表
    getMessageList () {
      this.loading = true
      var para = this.filters
      para.toUserId = this.user.id
      doPost('/message/getMessageUserPageList', this.filters).then((res) => {
        console.log(res.result)
        this.total = res.result.total
        this.messageList = res.result.list
        this.loading = false
      })
    },
    downloadUser () {
      // axios下载数据
      download('/user/downloadUser', this.filters, '用户数据.xls')
    },
    // 删除
    handleDel: function (index, row) {
    },
    // 显示新增界面
    handleAdd: function () {
      this.addFormVisible = true
      this.addForm = {
        systemFlag: 'service-mdinfo',
        roleName: '',
        description: ''
      }
      this.messageTitle = '新增'
      this.messageSuc = '新增成功'
    },
    readMessage (id) {
      var para = { messageUserId: id }
      doPost('/message/readMessage', para).then((res) => {
        this.$message({
          message: '消息已读',
          type: 'success'
        })
        this.getMessageList()
      })
    },
    // 全部已读
    handleAllRead () {
      var para = {
        toUserId: this.user.id,
        status: 1
      }
      doPost('/message/allReadMessage', para).then((res) => {
        this.$message({
          message: '消息全部已读',
          type: 'success'
        })
        this.getMessageList()
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    // 批量删除
    batchRemove: function () {
    },
    statusFormatter (row, column) {
      if (row.status === 1) {
        return '未读'
      } else if (row.status === 2) {
        return '已读'
      }
    }
  },
  mounted () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    this.getMessageList()
  }
}

</script>

<style scoped>

</style>
